/**
 * @description 添加tag
 */

/************************************** Module ***********************************************/

/************************************** less文件 ***********************************************/
import './qp-tags.less';

/************************************** js文件 ***********************************************/

/************************************** Service ***********************************************/

/************************************** Component ***********************************************/

/************************************** Provider ***********************************************/
import { QpTagsDirective } from "./qp-tags.directive";

/************************************** Directive ***********************************************/

/************************************** Controller ***********************************************/

/************************************** Regist ***********************************************/
let qpTagsModule = angular.module("qpmn-qp-tags", []);

qpTagsModule
    .directive({
        qpTags: QpTagsDirective
    })

export { qpTagsModule }